import { css } from "@linaria/core";

export const description = css`
  white-space: pre-wrap;
`;

export const editForm = css`
  max-width: 600px;
`;

export const fieldLabel = css`
  display: block;
  margin-bottom: var(--ant-margin-xs);
`;

export const savingText = css`
  font-size: var(--ant-font-size-sm);
`;
